import React from 'react';
import { motion } from 'framer-motion';

const steps = [
  { num: '01', title: 'Listen', desc: 'We start with conversation — understanding how you live, what you love, and what the space needs to do.' },
  { num: '02', title: 'Concept', desc: 'Mood, palette, and layout take shape. We present a clear creative direction before a single wall moves.' },
  { num: '03', title: 'Develop', desc: 'Drawings, samples, sourcing, and the careful work of refining every detail with our trusted makers.' },
  { num: '04', title: 'Reveal', desc: 'We style, we finesse, and we hand you the keys to a home that feels unmistakably yours.' }
];

function ProcessSection() {
  return (
    <section className="process-section section-wrap" id="process">
      <div className="section-heading">
        <div>
          <p className="eyebrow">How we work</p>
          <h2>
            A process built
            <br />
            on <em>trust.</em>
          </h2>
        </div>
        <p className="section-intro">
          No surprises, no jargon. Just a clear, considered path from the first hello to the final reveal.
        </p>
      </div>
      <div className="process-grid">
        {steps.map((step, i) => (
          <motion.div
            key={step.num}
            className="process-step"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.5, delay: i * 0.12 }}
          >
            <span className="process-num">{step.num}</span>
            <h3>{step.title}</h3>
            <p>{step.desc}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
}

export default ProcessSection;
